import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>🎰 로또운세</h3>
            <p>로또 번호 추천과 오늘의 운세를 한 곳에서</p>
          </div>

          <div className="footer-section">
            <h4>서비스</h4>
            <ul>
              <li><Link to="/lotto">로또 번호 생성</Link></li>
              <li><Link to="/fortune/zodiac">별자리 운세</Link></li>
              <li><Link to="/fortune/chinese">띠 운세</Link></li>
              <li><Link to="/fortune/tarot">타로 카드</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>정보</h4>
            <ul>
              <li><Link to="/stats">통계</Link></li>
              <li><Link to="/blog">블로그</Link></li>
              <li><Link to="/about">소개</Link></li>
              <li><Link to="/contact">문의하기</Link></li>
              <li><a href="https://dhlottery.co.kr" target="_blank" rel="noopener noreferrer">
                동행복권
              </a></li>
            </ul>
          </div>
        </div>

        <div className="footer-links">
          <Link to="/privacy">개인정보처리방침</Link>
          <span className="separator">|</span>
          <Link to="/terms">이용약관</Link>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} lottounse.kr. All rights reserved.</p>
          <p className="disclaimer">
            본 서비스는 재미와 참고용으로만 사용하시기 바랍니다.
            로또 당첨을 보장하지 않으며, 운세는 오락 목적입니다.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
